export default "__VITE_ASSET__PyTX4Ivf__"